import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewbox="0 0 20 20" fill="none"><path fill="currentColor" d="M13.073 9.963c-.572-.35-.39-.105-.15.126 1.023.966 1.7 1.914 1.952 2.737.164.535.017.861-.227.392-.374-.71-.862-1.257-1.163-1.498-.296-.238-.29-.123-.146.066.583.78.928 1.565.583 2.174-.57.998-2.863.746-5.118-.56-2.87-1.66-4.64-3.931-3.99-5.093.282-.508 1.05-.718 1.958-.64.192.017.181-.046.01-.092-1.082-.287-2.36-.017-2.813.774-.828 1.438 1.1 4.113 4.308 5.972.68.392 1.567.833 2.614 1.183.636.213.545.469-.548.255-1.159-.224-2.604-.83-3.969-1.634-.395-.231-.447-.14-.154.147.273.266.786.672 1.41 1.043 3.185 1.9 7.161 2.398 8.302.413 1.02-1.775-.813-4.516-2.859-5.765Z"></path><path fill="currentColor" d="M2.999 3 4.71 6.112h3.734v5.879c-.051-.04.048.038 0 0 .863.656 2.16 1.311 3.112 1.43-.049-.003.05.006 0 0V6.11h3.734L17 3H2.999Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
